@if (organization) {
	<div>
		<div class="section-title">{{organization.name}}</div>
		<hr>
		<div class="panel expander">
			<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Add new fleet</div>
			<div class="content">
				<form>
					<div class="mb-3 row">
						<label class="col-md-4">Fleet name</label>
						<div class="col-md-8">
							<input [(ngModel)]="newFleetName" name="fleet_name" type="text" class="form-control">
						</div>
					</div>
					<div class="mb-3 row">
						<div class="col-md-8 offset-md-4">
							<app-action-button submit [action]="AddFleet" [context]="this" processing="Adding..." complete="Fleet added">Add Fleet</app-action-button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
}